// Format date from API to local date format
export const formatDate = (dateString) => {
    if (!dateString || dateString === '0001-01-01T00:00:00' || dateString === '1753-01-01T00:00:00') {
      return '-';
    }
    return new Date(dateString).toLocaleDateString('fr-FR');
  };
  
  // Format empty or null values
  export const formatValue = (value, defaultValue = '-') => {
    return value || defaultValue;
  };